import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BaseRegulatorySectionComponent } from '../../../common/base-regulatory-section/base-regulatory-section.component';
import { RegepCommentsService } from 'src/app/+regep/services/regep-comments.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { RegepTechnicalResourceService } from '../../../regep-technical-resource/regep-technical-resource.service';
import { ControlContainer, FormGroup, NgForm } from '@angular/forms';
import { RegepOrderProcessService } from 'src/app/+regep/services/regep-order-process.service';

@Component({
  selector: 'app-energy-producers-registration',
  templateUrl: './energy-producers-registration.component.html',
  styleUrls: ['./energy-producers-registration.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class EnergyProducersRegistrationComponent extends BaseRegulatorySectionComponent implements OnInit {
  @Output() eegEnergyProducersFormChanged = new EventEmitter<FormGroup>();
  @Output() changeCommentText = new EventEmitter<string>();

  constructor(
    commentService: RegepCommentsService,
    environmentService: EnvironmentService,
    orderProcessService: RegepOrderProcessService,
    private readonly technicalResourceService: RegepTechnicalResourceService
  ) {
    super(commentService, environmentService, orderProcessService);
  }

  ngOnInit(): void {
    this.preventLeak(this.technicalResourceService.getEegEnergyProducers()).subscribe(
      energyProducers => (this.regulatoryData.eeg_energy_producers = energyProducers)
    );

    this.preventLeak(this.technicalResourceService.getFormState()).subscribe(formState => {
      this.eegEnergyProducersFormChanged.emit(formState);
    });
  }

  protected get sectionComment(): string {
    return this.regulatoryData.regulatory_data_sections_state?.marktstammdatenregister_registration_comment;
  }

  protected set sectionComment(value: string) {
    this.regulatoryData.regulatory_data_sections_state.marktstammdatenregister_registration_comment = value;
  }

  protected get sectionLocked(): boolean {
    return this.regulatoryData.regulatory_data_sections_state?.is_marktstammdatenregister_registration_locked;
  }

  protected set sectionLocked(value: boolean) {
    this.regulatoryData.regulatory_data_sections_state.is_marktstammdatenregister_registration_locked = value;
  }
}
